import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { BehaviorSubject } from 'rxjs';
import { AnalysisCalculatorComponent, NAnalysisCalculator } from './analysis-calculator.component';

@ICmsComponent<CmsAnalysisCalculatorComponent>({
    id: 'analysis-calculator',
    name: 'Analysis Calculator',
    tags: ['calculator', 'analysis', 'analysis-calculator'],
    isAdvanced: true,
    fields: NAnalysisCalculator.getFields()
})
@Component({
    imports: [AnalysisCalculatorComponent],
    selector: 'cms-analysis-calculator',
    templateUrl: './cms-analysis-calculator.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsAnalysisCalculatorComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component?: NAnalysisCalculator.IComponentData;

    _icmsContent$!: BehaviorSubject<NICmsContentComponent.IData | undefined>;

    protected productsIds: number[] = [];

    override ngOnInit() {
        super.ngOnInit();

        if (this._icmsContent$) {
            this.subscriptions.add(
                this._icmsContent$.subscribe(() => {
                    this.productsIds = this.component?.productsIds ?? [];
                    this.detectChanges();
                })
            );
        }
    }
}
